"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useRateLimitedState = require("./useRateLimitedState.cjs");
function useRateLimitedValue(value, options, selector) {
  const [rateLimitedValue, setRateLimitedValue, rateLimiter] = useRateLimitedState.useRateLimitedState(value, options, selector);
  react.useEffect(() => {
    setRateLimitedValue(value);
  }, [value, setRateLimitedValue]);
  return [rateLimitedValue, rateLimiter];
}
exports.useRateLimitedValue = useRateLimitedValue;
//# sourceMappingURL=useRateLimitedValue.cjs.map
